export const API_ENDPOINTS = {
  auth: {
    login: '/v1/auth/login',
    logout: '/v1/auth/logout',
    forgotPassword: '/v1/auth/password-forgot',
    verifyPasswordResetToken: '/v1/auth/password-reset-verify',
    resetPassword: '/v1/auth/password-reset',
    changePassword: '/v1/auth/password-change',
    setPassword: '/v1/auth/password-set',
    account: '/v1/auth/profile',
  },
  forms: {
    list: '/surveyor/forms',
    details: (id) => `/surveyor/forms/${id}`,
  },
  submissions: {
    list: '/surveyor/form-submissions',
    submit: '/surveyor/form-submissions',
    details: (id) => `/surveyor/form-submissions/${id}`,
    update: (id) => `/surveyor/form-submissions/${id}`,
    delete: (id) => `/surveyor/form-submissions/${id}`,
    uploadFiles: (id) => `/surveyor/form-submissions/${id}/upload-files`,
    offlineSync: '/surveyor/form-submissions/offline-sync',
  },
  analytics: {
    stats: '/surveyor/analytics/stats',
  },
  entities: {
    list: '/entity/v1/entities',
    listByType: (id) => `/entity/v1/entity-types/${id}`,
    create: '/entity/v1/entities',
    getById: (id) => `/entity/v1/entities/${id}`,
    update: (id) => `/entity/v1/entities/${id}`,
    types: '/entity/v1/entity-types',
  },
  admin: {
    teams: '/admin/teams',
  },
  chats: {
    generateToken: '/v1/chats/generate-token',
    teamMembers: '/v1/chats/team-members',
    rooms: '/v1/chats/rooms',
  },
  wizards: {
    getById: (wizardKey) => `/v1/wizards/${wizardKey}`,
    saveStep: (wizardKey) => `/v1/wizards/${wizardKey}/step`,
    complete: (wizardKey) => `/v1/wizards/${wizardKey}/complete`,
  },
};